import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MedicalFeeService } from '../../../services/medical-fee/medical-fee.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { NotificationToastService } from '../../../services/notification-toast.service';

@Component({
  selector: 'app-medical-fee-payment-aliquot',
  templateUrl: './medical-fee-payment-aliquot.component.html',
  styleUrls: ['./medical-fee-payment-aliquot.component.css']
})
export class MedicalFeePaymentAliquotComponent implements OnInit {

  @Input() physicianId?: number;
  form: FormGroup;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;
  displayedColumns: string[] = ['Aliquot', 'Amount', 'PercentageText'];
  dataSource = new MatTableDataSource([]);
  loading: boolean;
  total: string;

  constructor( private medicalFeeService: MedicalFeeService,
               private notificationToastService: NotificationToastService,
               private formBuilder: FormBuilder ) {

    const today = new Date();

    this.form = this.formBuilder.group({
      from: [ new Date( today.getFullYear(), today.getMonth(), 1 ) , Validators.required ],
      to: [ today , Validators.required ]
    });

  }

  ngOnInit() {

  }

  get f() { return this.form.controls; }

  async search() {

    if ( this.form.valid && this.physicianId ) {

      try {

        this.loading = true;

        const from = this.form.controls.from.value;
        const to = this.form.controls.to.value;

        const items = await this.medicalFeeService
          .getMedicalFeePhysicianAliquots( this.physicianId, from, to );

        this.pager.setItems( items );

        if ( items.length > 0 ) {
          this.total = `Total ${ items[0].TotalText }`;
        } else {
          this.total = `Total 0`;
        }

      } catch ( err ) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Honorarios');
      } finally {
        this.loading = false;
      }
    }
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  async realoadIfRequired( physicianId?: number ) {

    if ( this.physicianId !== physicianId ) {
      this.physicianId = physicianId;
      this.pager.setItems( [] );
      this.total = '';
    }

  }
}
